<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="60">
    <v-progress-linear :active="loading" :indeterminate="loading" absolute top
      color="deep-blue blue"></v-progress-linear>
    <v-btn class="mr-3" elevation="1" fab small @click="openMenu(value)">
      <v-icon v-if="value">mdi-view-quilt</v-icon>

      <v-icon v-else>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="computedTitle" />

    <!-- Help -->

    <v-spacer />

    <v-autocomplete v-model="selectedAppUrl" :items="listApp" item-text="descr" item-value="url" dense
      class="hidden-sm-and-down" :label="$t('search_app')"></v-autocomplete>
    <v-spacer />
    <div v-if="pwaPrompt">
      <!-- <v-btn @click="promptInstall" color="primary" icon><v-icon>mdi-application-import</v-icon></v-btn> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="primary" v-on="on" style="cursor: pointer" class="mx-2"
            @click.native="promptInstall()">mdi-application-cog-outline</v-icon>
        </template>
        <span>{{ $t("install_app") }}</span>
      </v-tooltip>
    </div>
    <chat v-if="notificationActive" v-bind:newMessage="newMessage"></chat>
    <get-online-users v-if="notificationActive"></get-online-users>
    <notification-panel v-if="notificationActive" v-bind:newNotify="newNotify"></notification-panel>
    <select-language />
    <div v-if="haveHelp">
      <v-btn @click="showHelp" color="primary" icon><v-icon>mdi-help-circle</v-icon></v-btn>
    </div>


  </v-app-bar>
</template>

<script>
import * as Push from "push.js";

// Widget
import getOnlineUsers from "@/widget/getOnlineUsers.vue";
import notificationPanel from "@/widget/notificationPanel.vue";
import selectLanguage from "@/widget/selectLanguage.vue";
import chat from "@/widget/chat.vue";

// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities

export default {
  name: "DashboardCoreAppBar",

  components: {
    getOnlineUsers,
    notificationPanel,
    selectLanguage,
    chat,
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newNotify: null,
      newMessage: null,
      descriptionLimit: 60,
      selectedAppUrl: "",
      listApp: [],
      notificationActive: false,
    };
  },

  methods: {
    async registerSw() {
      let _ = this;
      let registration = null;
      console.log("Registering MyASD service worker");
      try {
        registration = await navigator.serviceWorker.register(
          "/serviceWorker.js",
          { scope: "/" }
        );
        console.log("Registered MyASD service worker");
      } catch (err) {
        console.log("Error registering MyASD service worker", err);
      }

      if (!registration) {
        console.log("Skipping MyASD push registration: service worker registration unavailable");
        return;
      }

      console.log("Registering MyASD push");
      try {
        let subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          // The `urlBase64ToUint8Array()` function is the same as in
          // https://www.npmjs.com/package/web-push#using-vapid-key-for-applicationserverkey
          applicationServerKey: _.urlBase64ToUint8Array(
            window.systemData.vapidPublicKey
          ),
        });
        console.log("Registered MyASD push");

        console.log("Sending MyASD subscription");
        _.refreshToken("native", subscription);
        console.log("Sent MyASD subscription");
      } catch (err) {
        console.log("Error registering MyASD push", err);
      }

    },
    urlBase64ToUint8Array(base64String) {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    showHelp() {
      let url = "/public/portal/getRouteHelp?path=" + this.$route.path;
      this.$documentViewer.documentViewerRsp.docUrl = url;
    },
    receivedMessage(payload) {
      let _ = this;
      console.log("Message " + payload.data.type + " received. ");
      if (payload.data.type === "chat") {
        _.newMessage = payload.data;
        if (payload.data.mode === "notify") {
          Push.create(payload.data.title, {
            body: payload.data.body,
            icon: payload.data.senderFoto,
            timeout: 4000,
            vibrate: [200, 100],
            onClick: function () {
              window.focus();
              this.close();
            },
          });
        }
      } else {
        _.newNotify = payload.data;
        Push.create(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.image,
          timeout: 4000,
          vibrate: [200, 100],
          onClick: function () {
            window.focus();
            this.close();
          },
        });
      }
    },
    refreshToken(type, currentToken) {
      this.chiamataAxios("POST", "/auth/notify/refreshToken/" + type, {
        body: {
          token: currentToken,
        },
      });
    },
    openMenu(value) {
      let mobile = this.$vuetify.breakpoint.smAndDown;
      mobile ? this.$emit("openMenu", true) : this.$emit("input", !value);
    },
    moduleActive(module) {
      return window.systemData.modules.indexOf(module) > -1;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    onSelect(val) {
      this.$router.push({ path: val.url });
    },
    promptInstall: function () {
      let _ = this;
      // Show the prompt:
      this.$pwa.pwaRsp.prompt.prompt().then(prompt => {
        _.$pwa.pwaRsp.prompt = false;
        if (prompt.userChoice === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
      });
      _.$pwa.pwaRsp.prompt = false;
    }
  },
  watch: {
    selectedAppUrl: function (val) {
      this.$router.push(val);
    },
  },
  computed: {
    pwaPrompt() {
      return this.$pwa.pwaRsp.prompt;
    },
    verifyChangeAvatar() {
      return this.$changeAvatar.changeAvatarRsp.updated;
    },
    computedTitle: function () {
      let _ = this;
      let descr = _.$route.name
      if (_.listApp && _.listApp.length > 0) {
        for (let app of _.listApp) {
          let subPath = _.$route.path.substring(0, app.url.length)
          if (app.url === subPath) {
            if (window.selectedLanguage && app.translate[window.selectedLanguage] && app.translate[window.selectedLanguage].descr) descr = app.translate[window.selectedLanguage].descr
            else descr = app.descr;
            return descr;
          }
        }
      }
      return descr
    },
    loading() {
      return this.$globalHandler.loader.arrRqs.length > 0;
    },
    haveHelp() {
      if (
        window &&
        window.selectedLanguage &&
        window.systemData &&
        window.systemData.help &&
        window.systemData.help[window.selectedLanguage] &&
        window.systemData.help[window.selectedLanguage][this.$route.path]
      )
        return true;
      else return false;
    },
  },
  mounted() {
    let _ = this;
    if (window.systemData.notification) {
      _.notificationActive = true;
      _.registerSw();
    }
    // Ricerca app
    this.chiamataAxios("GET", "/auth/portal/listApp").then((response) => {
      let appList = response.data.filter(function (app) {
        if (app.url.toLowerCase() !== _.$route.path.split("/")[1].toLowerCase())
          return true;
        else return false;
      }).map(el => {
        if (window.selectedLanguage && el.translate[window.selectedLanguage] && el.translate[window.selectedLanguage].descr) el.descr = el.translate[window.selectedLanguage].descr
        return el;
      });
      _.listApp = appList;
    });
  },
};
</script>